<template>
  <div class="common__pageContainer__3-VhW">
    <div class="common__pageBody__1Dn3a">
      <div class="venueStyle__pages__3golT undefined venueStyle__zr__2WRy_" style="background-image: url(/static/image/bg.5858f002c2ae068f4d2657e4074dc97f.jpg); height: 800px">
        <div class="venueStyle__content__37kNp" v-if="$store.state.realbetList.length > 0">
          <div class="venueStyle__contentLeft__3bmvb" v-for="(item, index) in $store.state.realbetList" :key="index" v-if="type == index">
            <img :src="item.api_logo_img" width="450px" class="venueStyle__title__K3KhH" style="width: 450px; min-height: 124px; opacity: 1; margin-left: 0px" /><span class="venueStyle__subTitle__2nKwg"
              >业内独家多机位百家乐真人游戏，惊艳、美丽、专业的荷官，高清真实的现场环境，为您呈现奢华游戏体验！
              <ul class="venueStyle__icons__kTABJ">
                <li class="venueStyle__iconItem__26QEL"><img src="/static/image/icon-1.a22b97f337ffbc181e0a62558dc609b6.png" width="30px" style="" /><span class="venueStyle__iconText__3-V_q">百家乐</span></li>
                <li class="venueStyle__iconItem__26QEL"><img src="/static/image/icon-2.589a9db6ce0a5e965a797843c7e27ced.png" width="30px" style="" /><span class="venueStyle__iconText__3-V_q">龙虎</span></li>
                <li class="venueStyle__iconItem__26QEL"><img src="/static/image/icon-3.9aa174e9d05f2451283fa8220678554e.png" width="30px" style="" /><span class="venueStyle__iconText__3-V_q">骰宝</span></li>
                <li class="venueStyle__iconItem__26QEL"><img src="/static/image/icon-4.e2a168915d33fdef12434ac275146c8f.png" width="30px" style="" /><span class="venueStyle__iconText__3-V_q">轮盘</span></li>
                <li class="venueStyle__iconItem__26QEL"><img src="/static/image/icon-5.70e44006894fa46044ff62ff22b4a429.png" width="30px" style="" /><span class="venueStyle__iconText__3-V_q">牛牛</span></li>
                <li class="venueStyle__iconItem__26QEL"><img src="/static/image/icon-6.2890aaa13864842c47bc689e6996e904.png" width="30px" style="" /><span class="venueStyle__iconText__3-V_q">炸金花</span></li>
              </ul>
            </span>
            <a id="gotogames" class="gotogames" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"><img src="/static/image/btn.1cfd2c8e17e20f1631dd11d7504e717d.png" width="176px" class="venueStyle__btn__HuPwB" style="margin-top: 25px; margin-left: -3px" /> </a>
          </div>
          <div class="venueStyle__models__zXaM0"><img :src="`/static/realbet/${type}.png`" width="800px" class="myImg" style="margin-left: -28px; opacity: 1" /></div>

          <ul class="venueStyle__tabs__3wTus" style="margin-left: -132px">
            <li class="venueStyle__tabItem__11CR_" v-for="(item, index) in $store.state.realbetList" :key="index" @click="changType(index)">
              <img v-if="type == index" :src="item.check_yes_img" width="180px" style="" />
              <img v-else :src="item.check_no_img" width="180px" style="" />
            </li>
          </ul>
          <img src="/static/image/anm-ob-1.c2c95beac7b57cad2e6711b6c97ea63a.png" width="72px" class="venueStyle__anm__3WJmq xf_img1" style="left: -201px; top: 94px" />
          <img src="/static/image/anm-ob-2.0ba124fbac5f79fc4f688870dcd6c251.png" width="68px" class="venueStyle__anmTwo__1r2lK xf_img2" style="left: 235px; top: 664px" />
          <img src="/static/image/anm-ob-3.35306cd51b3a351d3dea16f7d0b41a51.png" width="46px" class="venueStyle__anm__3WJmq xf_img3" style="left: 552px; top: 377px" />
          <img src="/static/image/anm-ob-4.8bb599d862699b9f8ee9adf07fa91368.png" width="66px" class="venueStyle__anmTwo__1r2lK xf_img4" style="left: 992px; top: 186px" />
          <img src="/static/image/anm-ob-5.a3d992b84fa2530cd3c9f6a5003ac1bb.png" width="92px" class="venueStyle__anm__3WJmq xf_img5" style="left: 1028px; top: 577px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'realbet',
  data() {
    return {
      type: 0,
    };
  },
  created() {
    let that = this;
  },
  methods: {
    changType(index) {
      let that = this;
      that.type = index;
    },
  },
  mounted() {
    let that = this;

    $('.venueStyle__title__K3KhH ').css({ 'margin-left': '-68px' });
    $('.venueStyle__title__K3KhH ').animate({ 'margin-left': '-0px' }, 400);

    $('.gotogames img ').css({ 'margin-left': '-128px' });
    $('.gotogames img ').animate({ 'margin-left': '-0px' }, 400);
    $('.venueStyle__subTitle__2nKwg ').css({ 'margin-left': '-128px' });
    $('.venueStyle__subTitle__2nKwg ').animate({ 'margin-left': '-0px' }, 200);
    $('.venueStyle__models__zXaM0 img').css({ 'margin-left': '-28px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'margin-left': '-108px' }, 400);
  },
  updated() {
    let that = this;
    $('.venueStyle__title__K3KhH ').css({ 'margin-left': '-68px' });
    $('.venueStyle__title__K3KhH ').animate({ 'margin-left': '-0px' }, 400);
        $('.gotogames img ').css({ 'margin-left': '-128px' });
    $('.gotogames img ').animate({ 'margin-left': '-0px' }, 400);
        $('.venueStyle__subTitle__2nKwg ').css({ 'margin-left': '-128px' });
    $('.venueStyle__subTitle__2nKwg ').animate({ 'margin-left': '-0px' }, 200);
    $('.venueStyle__models__zXaM0 img').css({ 'margin-left': '-28px' });
    $('.venueStyle__models__zXaM0 img').animate({ 'margin-left': '-108px' }, 400);
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '/static/css/Lottery_793450d6.8907158d.css';
//@import '/style.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/realbet.vue